var map = {
	"./click.svg": "ckQy",
	"./health-icon1.svg": "+pcq",
	"./health-icon2.svg": "rPsk",
	"./health-icon3.svg": "S0rG",
	"./health-icon4.svg": "W7Eh",
	"./learning1.svg": "RC9a",
	"./learning2.svg": "/LpD",
	"./learning3.svg": "9km0",
	"./learning4.svg": "SPp3",
	"./learning5.svg": "ex0z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 24